import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Button from '../components/common/Button';
import { handleApiError } from '../api/client';
import { useAuth } from '../contexts/AuthContext';

const LoginPage: React.FC = () => {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    if (user) return <Navigate to="/dashboard" replace />;

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        try {
            setLoading(true);
            setError('');
            await login(email, password);
            navigate('/dashboard');
        } catch (err) {
            setError(handleApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
            <div className="w-full max-w-md bg-white border border-gray-200 rounded-lg shadow-sm p-8">
                <div className="mb-8">
                    <img src="/logo-brand.png" alt="" className="mb-5 h-24 w-auto object-contain" />
                    <h1 className="text-2xl font-bold text-gray-900">Sign in to </h1>
                    <p className="text-gray-600 mt-2">Secure access for campaign operations and reporting.</p>
                </div>
                {error && <div className="mb-4 rounded-md bg-red-50 text-red-700 px-4 py-3 text-sm">{error}</div>}
                <form onSubmit={handleSubmit} className="space-y-5">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <Button type="submit" fullWidth loading={loading}>Sign in</Button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
